import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const items = [
  {
    title: 'Chiptuning',
    description: 'Maximaliseer het potentieel van uw voertuig met chiptuning. Onze geavanceerde software-optimalisatie zorgt voor meer vermogen, een beter koppel en een soepelere rijervaring – volledig afgestemd op uw motor.',
    image: 'https://lozejxkhsvwkksgzhrfd.supabase.co/storage/v1/object/public/images/GP%20Products-11.jpg',
  },
  {
    title: 'Uitlaatsystemen',
    description: 'Premium uitlaatsystemen voor de perfecte balans tussen prestaties en geluid. Van subtiel sportief tot race-klaar – wij leveren en monteren systemen van de beste merken, volledig op maat.',
    image: 'https://lozejxkhsvwkksgzhrfd.supabase.co/storage/v1/object/public/images/mods.jpg',
  },
  {
    title: 'Modificaties',
    description: 'Van performance upgrades tot esthetische aanpassingen. Wij transformeren uw voertuig naar uw wensen met hoogwaardige onderdelen en vakkundig maatwerk van onze specialisten.',
    image: 'https://lozejxkhsvwkksgzhrfd.supabase.co/storage/v1/object/public/images/tuningkits.jpg',
  },
];

const ExpertiseShowcase = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section className="relative w-full h-[90vh] min-h-[600px] overflow-hidden">
      {/* Background images */}
      {items.map((item, i) => (
        <motion.div
          key={i}
          className="absolute inset-0"
          initial={false}
          animate={{ opacity: activeIndex === i ? 1 : 0 }}
          transition={{ duration: 0.8, ease: 'easeInOut' }}
        >
          <img
            src={item.image}
            alt={item.title}
            className="w-full h-full object-cover"
          />
        </motion.div>
      ))}

      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/55" />

      {/* Content grid: exact domogo layout */}
      <div className="relative z-10 h-full max-w-[1400px] mx-auto px-6 md:px-16 lg:px-20 flex flex-col justify-center md:grid md:grid-cols-2 gap-6 md:gap-8">
        {/* Left column: items vertically centered */}
        <div className="flex flex-col justify-center">
          {items.map((item, i) => (
            <div
              key={i}
              className="cursor-pointer"
              onMouseEnter={() => setActiveIndex(i)}
              onClick={() => setActiveIndex(i)}
            >
              {i > 0 && <div className="h-px bg-white/15 my-1" />}
              <div className="flex items-center py-3 md:py-4">
                <motion.h3
                  className="text-white tracking-tight"
                  animate={{ opacity: activeIndex === i ? 1 : 0.35 }}
                  transition={{ duration: 0.3 }}
                  style={{
                    fontFamily: "'Manrope', sans-serif",
                    fontSize: 'clamp(1.5rem, 3.5vw, 2.75rem)',
                    fontWeight: 500,
                    lineHeight: 1.1,
                  }}
                >
                  {item.title}
                </motion.h3>
              </div>
            </div>
          ))}
        </div>

        {/* Right column: description */}
        <div className="flex flex-col justify-center md:pl-12">
          <AnimatePresence mode="wait">
            <motion.p
              key={activeIndex}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.4 }}
              className="text-white/80 text-[13px] md:text-[15px] leading-[1.8] max-w-sm"
              style={{ fontFamily: "'Manrope', sans-serif" }}
            >
              {items[activeIndex].description}
            </motion.p>
          </AnimatePresence>
        </div>
      </div>
    </section>
  );
};

export default ExpertiseShowcase;
